import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a dots icon (that looks like '...').
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <OrderSchedulesIcon width={12} />
 */
const OrderSchedulesIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M42.65,15.77h-7a5,5,0,0,0-9.38,0h-7A3.35,3.35,0,0,0,16,19.1l-.07,23a3.33,3.33,0,0,0,3.33,
            3.32H42.58a3.33,3.33,0,0,0,3.33-3.32l.09-23A3.35,3.35,0,0,0,42.65,15.77ZM31,15.77a1.67,1.67,0,1,
            1-1.67,1.67h0A1.69,1.69,0,0,1,31,15.77Zm3.32,23.3H22.68a1.66,1.66,0,1,1,0-3.32H34.33a1.66,1.66,0,1,1,0,
            3.32Zm5-6.66H22.68a1.66,1.66,0,0,1,0-3.32H39.32a1.66,1.66,0,0,1,0,3.32Zm0-6.66H22.68a1.66,1.66,0,0,1,
            0-3.32H39.32a1.67,1.67,0,0,1,0,3.33Z`}
        />
        <path
            d={`M12.5,28.17H8.72a1.66,1.66,0,0,1,0-3.32h3.79l0-3.34H8.72a1.66,1.66,0,0,1,0-3.32h3.83a6.06,6.06,0,0,
            1,1.19-3.34h-5a1.66,1.66,0,0,1,0-3.32h16.4a7.74,7.74,0,0,1,3.29-2.24A7.64,7.64,0,0,1,32,8.92V8.2a3.35,
            3.35,0,0,0-3.35-3.33h-7a5,5,0,0,0-9.38,0h-7A3.35,3.35,0,0,0,2.07,8.2L2,31.23a3.33,3.33,0,0,0,3.33,
            3.32h7.15Zm4.56-23.3a1.67,1.67,0,1,1-1.67,1.67A1.69,1.69,0,0,1,17.06,4.87Z`}
        />
    </SvgIcon>
)

OrderSchedulesIcon.defaultProps = defaultProps

export { OrderSchedulesIcon }
